export default "__VITE_ASSET__Dg$SeN_F__"